import React, { useState, useEffect } from 'react'
import BackNextButtons from './BackNextButtons';
import { makeStyles } from '@material-ui/core/styles';
import PlanRates from '../includes/planRates';

const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
      fill="#5A858E"
    />
  </svg>
);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: "8px 16px 0 0",
    textAlign: "left",
    fontSize: "1.2rem",
  },
  notificationBox: {
    backgroundColor: "transparent",
    padding: "16px 0",
    boxShadow:"none",
    border: "none",
    display: "none", // Initially hidden
  },
  notificationBoxVisible: {
    display: "block", // Visible when toggled
  },
  viewTermsButton: {
    cursor: "pointer",
    display: "flex",
    padding: "12px 0",
    alignItems: "center",
    borderRadius: "0",
    justifyContent: "space-between",
    backgroundColor: "transparent",
    borderBottom: "1px solid #5A858E",
  },
  infoIcon: {
    marginRight: "8px",
  },
}));

export default function EstimatedRates(props) {
  const classes = useStyles();
  const [isNotificationVisible, setNotificationVisible] = useState(false);
  const [totalRatePlans, setTotalRatePlans] = useState(0);

  const toggleNotificationBox = () => {
    setNotificationVisible(!isNotificationVisible);
  };

  useEffect(() => {

    let totalRatePlans = props.values.ratePlans.length - 1;
    let powerRatePlansCount = 0;
    props.values.ratePlans.forEach(plan => {
      if (plan.apiType === "power" && props.values.exportMeter === false && props.values.isSmartMeter === true && props.values.isAdditionalProperty !== 'yes') {
        powerRatePlansCount++;
      }
    });
    totalRatePlans += powerRatePlansCount;

    //console.log('totalRatePlans',totalRatePlans);
    setTotalRatePlans(totalRatePlans);
  }, []);
  
  return (
    <div className="choose-plan-page">

      {totalRatePlans < 2 ? (
        <h2>{props.forms.ChooseYourPlanTitle}</h2>
      ) : (
        <div className="choose-plan-page__header" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h2>{props.forms.ChooseYourPlanTitle}</h2>
          {/* <p className="choose-plan-page__header-plans">{totalRatePlans} Plans Available</p> */}
        </div>
      )}

      <div className={`choose-plan-page__wrapper ${totalRatePlans > 2 ? 'choose-plan-page__wrapper-col' : ''}`}>

        {props.values.ratePlans.map((plan, index) => (
          ((plan.apiType === "power" || plan.apiType === "lunch") && props.values.exportMeter === false && props.values.isSmartMeter === true && props.values.isAdditionalProperty !== 'yes') ? (
            <PlanRates 
              key={index}
              handleChange={props.handleChange}
              values={props.values}
              planRate={plan}
              nextStep={props.nextStep}
              totalRateCount={totalRatePlans}
              handleNoGstChange={props.handleNoGstChange} 
              noGst={props.noGst}
              forms={props.forms}
            />
          ) : (plan.apiType !== "power" && plan.apiType !== "lunch") && <PlanRates 
                                            key={index}
                                            handleChange={props.handleChange}
                                            values={props.values}
                                            planRate={plan}
                                            nextStep={props.nextStep}
                                            totalRateCount={totalRatePlans}
                                            handleNoGstChange={props.handleNoGstChange} 
                                            noGst={props.noGst}
                                            forms={props.forms}
                                          />
        ))}

        <div
          className="col-12 mobile-terms"
          id="notificationMobileBox"
        >
          <InfoIcon />
          <div className={classes.viewTermsButton} onClick={toggleNotificationBox}>
            <span style={{fontWeight:"700",color:"#5A858E",fontSize:"14px"}}>
               View Terms
            </span>
            <span>{isNotificationVisible ? <svg
                            width={10}
                            height={5}
                            viewBox="0 0 10 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ transition: "transform 0.3s", transform: "rotate(180deg)", marginBottom:"0 !important;" }}
                          >
                            <path
                              d="M1 0.5L5 4.5L9 0.5"
                              stroke="#030904"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          : <svg
                              width={10}
                              height={5}
                              viewBox="0 0 10 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ transition: "transform 0.3s", marginBottom:"0 !important;" }}
                            >
                              <path
                                d="M1 0.5L5 4.5L9 0.5"
                                stroke="#030904"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>}</span>
          </div>
          <div 
            className={`${classes.notificationBox} ${
              isNotificationVisible ? classes.notificationBoxVisible : ""
            }`}
          >
            <p>Please note all prices quoted exclude GST.</p>
            <p>&nbsp;</p>
            <p>
              Prices are shown in cents and are based on the information you have
              provided.
            </p>
            <p>&nbsp;</p>
            <p>
              <a href="https://www.greypowerelectricity.co.nz/offers-and-promotion-terms-and-conditions/" target="_blank" rel="noopener">
                *Sign up promotional offer terms apply
              </a>
            </p>
            <p>&nbsp;</p>
            <p>
              ** It is not practical to flow through the per kWh Network charges
              for all networks. For some networks, Network Services charges will
              be calculated using published prices and other assumptions that
              allow us to recover network charges across our customer base on
              your network.
            </p>
          </div>
        </div>

      </div>

      <BackNextButtons
        values={props.values}
        prevStep={props.prevStep}
        id="EstimatedRates"
      />
    </div>
  );
}